module.exports = "<app-denials></app-denials>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-provider/denials-prov/denials-prov.component.html
// module id = 2405
// module chunks = 66